<div class="flex items-start gap-2">
  <mat-checkbox [checked]="checked"
                (change)="checkedChange.emit($event.checked)"
                [aria-labelledby]="labelId"
                color="primary"></mat-checkbox>
  <!-- `pt-2.5` centres the first line on the 40px checkbox target against its 20px line box. -->
  <span [id]="labelId"
        class="text-sm text-default-gray whitespace-normal pt-2.5 hover:cursor-pointer"
        (click)="checkedChange.emit(!checked)">
    {{ 'components.accept_legal.checkbox_before' | translate }}<button
            type="button"
            class="link-button text-link-highlight underline hover:cursor-pointer"
            (click)="documentOpened.emit(); $event.stopPropagation()">{{ titleKey | translate }}</button>{{ 'components.accept_legal.checkbox_after' | translate }}
  </span>
</div>
